import React from 'react';

export default function ConflictBanner({ count = 0, onReview }) {
  if (!count) return null;
  return (
    <div className="mb-4 p-4 bg-[rgba(255,59,48,0.08)] border border-[rgba(255,59,48,0.25)] rounded-lg">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-white text-[12px] font-medium">Sync conflicts detected</p>
          <p className="text-white text-[11px] opacity-70 mt-1">
            {count} item{count === 1 ? '' : 's'} changed in both Dizee and Google. Review to choose what wins.
          </p>
        </div>
        <button
          onClick={onReview}
          className="px-3 py-2 rounded-lg text-[11px] bg-[#FF3B30] hover:opacity-90 transition-all text-white font-medium whitespace-nowrap"
        >
          Review
        </button>
      </div>
    </div>
  );
}


